import BaseChangeset from './base';
export class LoginChangeset extends BaseChangeset {}